import React from "react";
import { Reveal, Label, Display } from "./ui";
import { GALLERY } from "./siteData";

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <div className="mx-auto max-w-[1400px] px-6 pb-14 pt-14 lg:px-12 lg:pt-20">
        <Reveal><Label>Gallery</Label><Display className="mt-6 max-w-3xl text-5xl leading-[1.05] sm:text-6xl">Textures, spaces & finished stories.</Display></Reveal>
      </div>
      <section className="mx-auto max-w-[1400px] px-6 pb-28 lg:px-12">
        <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6">
          {GALLERY.map((img, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <div className="overflow-hidden rounded-md break-inside-avoid" data-testid={`gallery-item-${i}`}>
                <img src={img} alt="Nayara gallery" loading="lazy" className="w-full object-cover transition-transform duration-700 hover:scale-105" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}